var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("TiptapEditor", {
    attrs: {
      placeholder: _vm.$t("chatbotv2.enterBotResponseHere"),
      "show-attributes": true,
      "show-emoji": true,
      "preview-mode": _vm.previewMode,
      "whatsapp-mode": _vm.whatsappMode,
      "allowed-attributes": _vm.allowedAttributes,
    },
    model: {
      value: _vm.text,
      callback: function ($$v) {
        _vm.text = $$v
      },
      expression: "text",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }